/* eslint-disable jsx-a11y/label-has-associated-control, jam3/no-sanitizer-with-danger */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ImageUploader from 'components_newui/new_ui_image_uploader/View'
import { useFormContext, Controller } from 'react-hook-form';
import Switch from '@material-ui/core/Switch';
import DOMPurify from 'dompurify';
import { decodeHtmlEntitiesFn } from 'services/RequestUtils';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    basicDetailWrp: {
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1.25rem',
        margin: '0 0 2rem 0',
        textAlign: 'left',
        color: "#333",
    },
    fieldsetBox: {
        marginBottom: theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label': {
            fontFamily: 'VodafoneRg-bold',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            display: 'block',
        },
        '& input[type="text"],input[type="date"],select ': {
            fontFamily: 'VodafoneRg-Regular',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            background: '#fff',
            borderRadius: '4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
        },
        '& input[type=date]:before': { content: 'none' },
        '& textarea': {
            fontFamily: 'VodafoneRg-Regular',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            background: '#fff',
            borderRadius: '4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize: 'none'
        },



    },
    '& input[aria-invalid="true"]': {
        borderColor: 'red',
    },
    error: {
        color: "red",
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1rem',
        margin: '0 0 0.5rem 0',
    },
    labelname: {
        fontFamily: 'VodafoneRg-bold',
        fontSize: '1.5rem',
        margin: '0 0 0.5rem 0',
        textAlign: 'left',
        color: "#333",
        display: 'block',
    },

    invalid: {
        borderColor: 'red !important',
    },


    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    challengeBox: {
        border: '1px solid #333',
        padding: '10px',
        overflow: 'auto',
        height: '290px',
        marginBottom: '8px',
    },
    switchBase: {
        padding:'9px !important',
        '&$checked': {
          color: '#008000', //  thumb
        },
        '&$checked + $track': {
          backgroundColor: '#008000', //  track
        },
    },
      checked: {},
      track: {},
}));

export const IdeaConfirmAndSubmit = (props) => {
    // console.log("IdeaConfirmAndSubmit edit idea", props)
    const { termAndCondition = '', InnovateIdeaStatus = "ACTIVE", getInnovateIdeaIdDetail } = props || {}
    const { isIdeaTermAccepted } = getInnovateIdeaIdDetail && getInnovateIdeaIdDetail.ideaForInnovater
    const classes = useStyles();

    const { register, control, watch, formState: { errors } } = useFormContext();
    // Watch value safely with default fallback
    const tncValue = watch('tncIdea') ?? isIdeaTermAccepted
    const [ideaOwnerMustApprove, setIdeaOwnerMustApprove] = React.useState(false)
    React.useEffect(() => {
        console.log('Switch value changed:', tncValue)
    }, [tncValue])



//   const decodeHtmlContent = decodeHtmlEntitiesFn(termAndCondition)


    const htmlToPlainText = (encodedString) => {
        if (!encodedString) return '';
    
        // Step 1: Decode HTML entities
        const parser = new DOMParser();
        const decoded = parser.parseFromString(encodedString, 'text/html').documentElement.textContent;
    
        // Step 2: Remove HTML tags
        const plainText = decoded.replace(/<[^>]*>/g, '');
        return plainText.trim();
      };


    // console.log("isIdeaTermAccepted", isIdeaTermAccepted)


    return (
        <div className={classes.basicDetailWrp}>
             <p className={classes.title}> Thank you for submitting an idea. You will be able to add team members to your idea on the idea page once submitted </p>
            <fieldset className={classes.fieldsetBox}>
                <label htmlFor='addInfo'>Additional info</label>
                <textarea
                    name="addInfo"
                    id='addInfo'
                    placeholder='idea additional info'
                    className={` ${errors?.termsAndConditions ? classes.invalid : ''}`}
                    {...register('addInfo')}
                />
                {errors?.addInfo?.message && <p className={classes.error}>{errors?.addInfo?.message}</p>}
            </fieldset>

            {InnovateIdeaStatus !== "ACTIVE" ?
                <fieldset className={classes.fieldsetBox}>
                    <h3>Challenge Terms and Conditions</h3>
                    <div className={classes.challengeBox}> 
                        {/* {htmlToPlainText(termAndCondition)}  */}

                        <div dangerouslySetInnerHTML={{ __html: DOMPurify?.sanitize(termAndCondition) }} />

                    </div>

                    <label htmlFor='tnc'>I/We confirm that I/we accept the Terms & Conditions of this Challenge.</label>
                    <Controller
                        name="tncIdea"
                        control={control}
                        defaultValue={isIdeaTermAccepted}
                        render={({ field }) => (
                            // <Switch
                            //     {...field}
                            //     checked={field.value ?? isIdeaTermAccepted}
                            //     onChange={
                            //         (e) => {
                            //             field.onChange(e.target.checked)         // update form state
                            //             // setIdeaOwnerMustApprove( e.target.checked) // update local state
                            //         }
                            //     }
                            //     name="tncIdea"
                            //     id="tnc"
                            //     inputProps={{ 'aria-label': 'checkbox' }}
                            // />
                            <Switch
                                {...field}
                                name="tncIdea"
                                checked={field.value ?? isIdeaTermAccepted}
                                onChange={(e) => field.onChange(e.target.checked)}
                                color="secondary"
                                id="tnc"
                                classes={{
                                    switchBase: classes.switchBase,
                                    checked: classes.checked,
                                    track: classes.track,
                                }}
                                inputProps={{ 'aria-label': 'confirm terms and conditions' }}
                            />
                        )}
                    />
                </fieldset>
                : null}
        </div>
    )
}
